export default __webpack_public_path__ + "static/media/swiftly-610.2485a4f1.mp3";